export const getRandomItem = (items: any[]) => {
  return items[Math.floor(Math.random() * items.length)]
}
